import { forwardRef, useCallback, useEffect, useMemo, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { TablePagination } from "@mui/material";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { QualidadeAcoesPreventivasForm } from "../../../schemas/AcoesMelhorias/qualidade_acoes_melhorias";
import { AcaoPrevCorretivaForm } from "../../../schemas/AcaoPrevCorretiva/qualidade_acoes_melhorias";
import { GenerateAcaoPrevCorretivaColumns } from "../columns/qualidade_acao_prev_corretiva";
import { AcaoPrevCorretivaPaginationStore } from "../../../hooks/Qualidade_acoes_prev_corretiva/pagination";
import { AcaoPrevCorretivasLista } from "../../../../domain/models/acao_prev_corretiva_lista";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { AcoePreventivasLista } from "../../../../domain/models/acoes_melhorias_lista";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import DeleteDialog from "../../../../../../common/components/delete_dialog";
import { GenerateAcaoPrevAnaliseEvidenciaColumns } from "../columns/qualidade_acao_prev_analise_evidencia";
import { usePageLoader } from "../../../../../../common/contexts/page_content_context";
import { AnaliseCriticaEvidenciaModal } from "./analise_critica_evidencia_modal";
import { AcoesModal } from "./acoes_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { DefaultFormDownloadInput } from "../../../../../../common/components/default_form_download_input";



type Props = {
  loading: boolean,
  saving: boolean;
  hookForm: UseFormReturn<QualidadeAcoesPreventivasForm>,
  hookFormPrev: UseFormReturn<AcaoPrevCorretivaForm>,
  centroCustoLista: CentroCustoDropDown[],
  selectedAcoesPrevintivas: AcoePreventivasLista | undefined,
  IdAcaoQualidade: number;
  handleDownload: (arquivoNome: string, imagePosition: number) => void;
  handleArquivoDeleteOpenState: (fileId: number | null) => void;
  onSubmitPrev: (e: AcaoPrevCorretivaForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void,

  //#region AcaoPrevCorretiva
  qualidadeAcaoPrevCorretivaLista: AcaoPrevCorretivasLista[];
  loadingPrev: boolean;
  handleTablePrevChange: (page: number) => Promise<void>;
  handleRowsPerTablePrevChange: (rowsPerPage: number) => void;
  paginationPrev: AcaoPrevCorretivaPaginationStore;
  handleDeleteConfirmaPrev: (IdAcaoPrevCorretiva: number, IdAcaoQualidade: number) => void;

  //#endregion
};

export const TabCadastroContent = forwardRef<HTMLButtonElement, Props>(({
  loading, saving, hookForm, centroCustoLista, IdAcaoQualidade, hookFormPrev, onOpenChangeHistory, loadingPrev, qualidadeAcaoPrevCorretivaLista, onSubmitPrev,
  selectedAcoesPrevintivas, handleArquivoDeleteOpenState, handleDownload, handleDeleteConfirmaPrev, handleRowsPerTablePrevChange, handleTablePrevChange, paginationPrev
}, ref) => {
  const [openAcaoPrev, setOpenAcaoAprev] = useState<boolean>(false);
  const [openAnalise, setOpenAnalise] = useState<boolean>(false);
  const [selectPrev, setSelectPrev] = useState<AcaoPrevCorretivasLista>();
  const [prevDeleteModal, setPrevDeleteModal] = useState<boolean>(false);
  const { pushWarnNotification } = usePageLoader();
  const statusAtual = hookForm.watch("AcaoAberta");
  const isReadOnly = statusAtual === 0;

  useEffect(() => {
    if (selectedAcoesPrevintivas) {
      if (selectedAcoesPrevintivas.Tipo) hookForm.setValue("Tipo", selectedAcoesPrevintivas.Tipo);

      const valorConvertido = selectedAcoesPrevintivas.AcaoAberta === true ? 1 : 0;
      hookForm.setValue("AcaoAberta", valorConvertido);

      hookForm.setValue("Abrangencia", selectedAcoesPrevintivas.Abrangencia);
      hookForm.setValue("AnaliseCausa", selectedAcoesPrevintivas.AnaliseCausa);
      hookForm.setValue("Assunto", selectedAcoesPrevintivas.Assunto);
      hookForm.setValue("Data", selectedAcoesPrevintivas.Data);
      hookForm.setValue("DescricaoProblema", selectedAcoesPrevintivas.DescricaoProblema);
      hookForm.setValue("DescricaoSetor", selectedAcoesPrevintivas.DescricaoSetor);
      hookForm.setValue("Evento", selectedAcoesPrevintivas.Evento);
      hookForm.setValue("EvidenciaObjetiva", selectedAcoesPrevintivas.EvidenciaObjetiva);
      hookForm.setValue("IdAcaoQualidade", selectedAcoesPrevintivas.IdAcaoQualidade);
      hookForm.setValue("IdCentroCusto", selectedAcoesPrevintivas.IdCentroCusto);
      hookForm.setValue("IdentificadoPor", selectedAcoesPrevintivas.IdentificadoPor);
      hookForm.setValue("Justificativa", selectedAcoesPrevintivas.Justificativa);
      hookForm.setValue("nomeArquivo1", selectedAcoesPrevintivas.nomeArquivo1);
      hookForm.setValue("nomeArquivo2", selectedAcoesPrevintivas.nomeArquivo2);
      hookForm.setValue("Numero", selectedAcoesPrevintivas.Numero);
      hookForm.setValue("RealizarAnalise", selectedAcoesPrevintivas.RealizarAnalise);
      hookForm.setValue("RequisitoNorma", selectedAcoesPrevintivas.RequisitoNorma);
    }
  }, [hookForm, selectedAcoesPrevintivas])

  const handleNewPrev = useCallback(async () => {
    setSelectPrev(undefined);
    hookFormPrev.reset();
    if (IdAcaoQualidade > 0 || selectedAcoesPrevintivas) {
      setPrevDeleteModal(false);
      setOpenAcaoAprev(true);
      let id = IdAcaoQualidade > 0 ? IdAcaoQualidade : selectedAcoesPrevintivas?.IdAcaoQualidade
      hookFormPrev.reset({ IdAcaoQualidade: id, Tipo: 'P' });
    }
    else {
      setPrevDeleteModal(false);
      setOpenAcaoAprev(false)
      pushWarnNotification("Atenção", "Para incluir uma programação é necessário salvar o cadastro.", { isAutoFinish: true })
    }
  }, [IdAcaoQualidade, hookFormPrev, pushWarnNotification, setSelectPrev, selectedAcoesPrevintivas])

  const handleLocalSubmit = async (data: AcaoPrevCorretivaForm) => {
    setOpenAcaoAprev(false);
    setOpenAnalise(false);
    await onSubmitPrev(data);
    const id = IdAcaoQualidade > 0 ? IdAcaoQualidade : selectedAcoesPrevintivas?.IdAcaoQualidade;
    hookFormPrev.reset({
      IdAcaoQualidade: id,
      Tipo: 'P',
      IdFuncionarioResponsavel: null,
      DataPrevista: null,
      DataRealizado: null,
      Numero: null,
      Descricao: null,

    });
  };

  const handleEdicaoOpenState = useCallback((IdAcaoPrevCorretiva: number | null, openState: boolean, openAnalise: boolean) => {
    if (openState) setOpenAcaoAprev(true);
    if (openAnalise) setOpenAnalise(true);

    if (IdAcaoPrevCorretiva) {
      const itemParaEditar = qualidadeAcaoPrevCorretivaLista.find(x => x.IdAcaoPrevCorretiva === IdAcaoPrevCorretiva);
      setSelectPrev(itemParaEditar);
    } else {
      hookFormPrev.reset();
    }
  }, [qualidadeAcaoPrevCorretivaLista, hookFormPrev]);

  const handleDeletePrevModalOpenState = useCallback((IdAcaoPrevCorretiva: number | null, openState: boolean) => {
    if (openState) {
      if (IdAcaoPrevCorretiva && qualidadeAcaoPrevCorretivaLista) {
        setSelectPrev(qualidadeAcaoPrevCorretivaLista.find(x => x.IdAcaoPrevCorretiva === IdAcaoPrevCorretiva));
      } else {
        setSelectPrev(undefined);
      }
    }
    setPrevDeleteModal(openState);
  }, [qualidadeAcaoPrevCorretivaLista]);

  const QualidadeAcaoPrevCorretivaListaColumns = useMemo(() => {
    return GenerateAcaoPrevCorretivaColumns({
      onActionEditar: handleEdicaoOpenState,
      onActionDeletar: handleDeletePrevModalOpenState,
      isReadOnly
    });
  }, [handleDeletePrevModalOpenState, handleEdicaoOpenState, isReadOnly]);

  const QualidadeAcaoPrevAnaliseEvidenciaListaColumns = useMemo(() => {
    return GenerateAcaoPrevAnaliseEvidenciaColumns({
      onActionEditar: handleEdicaoOpenState,
      isReadOnly
    });
  }, [handleEdicaoOpenState, isReadOnly]);


  return (
    <>
      <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
        <FormContainer title={"Informações"} arrangement="fullRow">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6">
              <FormDatePickerInput
                name='Data'
                label="Data"
                required={true}
                reactHookForm={hookForm}
                readOnly={isReadOnly}
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <DefaultFormAutocomplete
                name='IdCentroCusto'
                label='Centro de Custo'
                required={true}
                newButtonLabel='Novo'
                getOptionLabel={(x) => x.title}
                getOptionKey={(x) => x.id}
                options={centroCustoLista}
                reactHookForm={hookForm}
                readOnly={isReadOnly}
                onNew={() => { }}
              />
            </div>

            <div className="col-span-12 md:col-span-6">
              <DefaultFormInput
                name='DescricaoSetor'
                label='Setor'
                required={true}
                readOnly={isReadOnly}
                reactHookForm={hookForm}
              />
            </div>
            <div className="col-span-12">
              <DefaultFormInput
                name='IdentificadoPor'
                label="Identificado Por"
                readOnly={isReadOnly}
                reactHookForm={hookForm}
              />
            </div>
            <div className="col-span-12">
              <DefaultFormInput
                name='Evento'
                label="Evento"
                readOnly={isReadOnly}
                reactHookForm={hookForm}
              />
            </div>
            <div className="col-span-12">
              <DefaultFormInput
                name='Assunto'
                label="Assunto"
                readOnly={isReadOnly}
                reactHookForm={hookForm}
              />
            </div>
            <div className="col-span-12">
              <DefaultFormInput
                name='DescricaoProblema'
                label="Descrição da melhoria."
                multiline={true}
                readOnly={isReadOnly}
                rows={4}
                reactHookForm={hookForm}
              />
            </div>

            <div className="col-span-12">
              <DefaultFormInput
                name='RequisitoNorma'
                label="Requisito da norma e/ou documentação"
                multiline={true}
                readOnly={isReadOnly}
                rows={4}
                reactHookForm={hookForm}
              />
            </div>

            <div className="col-span-12">
              <DefaultFormInput
                name='Abrangencia'
                label="Abrangência (quais processos serão melhorados?)"
                multiline={true}
                readOnly={isReadOnly}
                rows={4}
                reactHookForm={hookForm}
              />
            </div>

            <div className="col-span-12">
              <DefaultFormInput
                name='AnaliseCausa'
                label="Quais os resultados esperados com a implantação da melhoria?"
                multiline={true}
                readOnly={isReadOnly}
                rows={4}
                reactHookForm={hookForm}
              />
            </div>

          </div>
        </FormContainer>
        <div>
          <span>Ações de melhorias</span>

          {isReadOnly === false && (
            <div className="w-40 mt-4  mb-4">
              <PrimaryButton
                type="button"
                onClick={handleNewPrev}
                buttonColor={"primary-green"}>
                Novo
              </PrimaryButton>
            </div>
          )}
          {qualidadeAcaoPrevCorretivaLista.length > 0 ? (
            <>
              <StyledDataGrid
                tableName="AcoesPreventivas"
                disableColumnMenu={false}
                getRowId={(row: AcaoPrevCorretivasLista) => row.IdAcaoPrevCorretiva}
                columns={QualidadeAcaoPrevCorretivaListaColumns}
                loading={loadingPrev}
                rows={qualidadeAcaoPrevCorretivaLista}
                rowCount={paginationPrev.totalItems}
                sx={{
                  '& .status-header': {
                    backgroundColor: '#AFDFD5',
                    color: '#000'
                  }
                }}
                autoHeight={true}
                textSize="medio"
                getRowHeight={() => "auto"}
                pageSizeOptions={[10]}
                paginationMode="server"
                paginationModel={{
                  page: paginationPrev.page - 1,
                  pageSize: paginationPrev.rowsPerPage,
                }} />

              <TablePagination
                component="div"
                count={paginationPrev.totalItems}
                page={paginationPrev.page - 1}
                onPageChange={(_, p) => handleTablePrevChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={paginationPrev.rowsPerPage}
                onRowsPerPageChange={(e) => handleRowsPerTablePrevChange(parseInt(e.target.value))} />

            </>
          ) : (<></>)}

          {qualidadeAcaoPrevCorretivaLista.length > 0 ? (
            <>
              <span>Análise crítica e evidência objetiva das ações</span>
              <StyledDataGrid
                tableName="AnaliseEficacia"
                disableColumnMenu={false}
                getRowId={(row: AcaoPrevCorretivasLista) => row.IdAcaoPrevCorretiva}
                columns={QualidadeAcaoPrevAnaliseEvidenciaListaColumns}
                loading={loadingPrev}
                rows={qualidadeAcaoPrevCorretivaLista}
                rowCount={paginationPrev.totalItems}
                sx={{
                  '& .status-header': {
                    backgroundColor: '#AFDFD5',
                    color: '#000'
                  }
                }}
                autoHeight={true}
                textSize="medio"
                getRowHeight={() => "auto"}
                pageSizeOptions={[10]}
                paginationMode="server"
                paginationModel={{
                  page: paginationPrev.page - 1,
                  pageSize: paginationPrev.rowsPerPage,
                }} />

              <TablePagination
                component="div"
                count={paginationPrev.totalItems}
                page={paginationPrev.page - 1}
                onPageChange={(_, p) => handleTablePrevChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={paginationPrev.rowsPerPage}
                onRowsPerPageChange={(e) => handleRowsPerTablePrevChange(parseInt(e.target.value))} />

            </>
          ) : (<></>)}
        </div>
        <FormContainer title={"Anexar Arquivos"} arrangement="fullRow">
          <>
            <div className="flex flex-row gap-x-8">
              <div className="flex-1">
                <DefaultFormDownloadInput
                  name='arquivo1'
                  nameLimparFlag='limparArquivo1'
                  saving={saving}
                  filename={selectedAcoesPrevintivas?.nomeArquivo1 ?? null}
                  reactHookForm={hookForm}
                  readOnly={isReadOnly}
                  onDownloadFile={filename => handleDownload(filename, 1)}
                  onDeleteFile={() => handleArquivoDeleteOpenState(1)}
                />
              </div>
              <div className="flex-1">
                <DefaultFormDownloadInput
                  name='arquivo2'
                  nameLimparFlag='limparArquivo2'
                  saving={saving}
                  readOnly={isReadOnly}
                  filename={selectedAcoesPrevintivas?.nomeArquivo2 ?? null}
                  reactHookForm={hookForm}
                  onDownloadFile={filename => handleDownload(filename, 2)}
                  onDeleteFile={() => handleArquivoDeleteOpenState(2)}
                />
              </div>
            </div>
          </>
        </FormContainer>
      </div>
      <DeleteDialog
        open={prevDeleteModal}
        saving={saving}
        onClose={() => handleDeletePrevModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={async () => {
          if (selectPrev && selectPrev.IdAcaoPrevCorretiva && selectPrev.IdAcaoQualidade) {
            await handleDeleteConfirmaPrev(
              selectPrev.IdAcaoPrevCorretiva,
              selectPrev.IdAcaoQualidade
            );
            handleDeletePrevModalOpenState(null, false);
          }
        }} />
      <AnaliseCriticaEvidenciaModal
        open={openAnalise}
        saving={saving}
        selectedAnalise={selectPrev ?? null}
        onSubmit={handleLocalSubmit}
        onClose={() => setOpenAnalise(false)}
        onOpenChangeHistory={(id, tabelaTipo) => onOpenChangeHistory(id, tabelaTipo)}
      />
      <AcoesModal
        open={openAcaoPrev}
        IdAcaoQualidade={IdAcaoQualidade}
        saving={saving}
        selectedAcoes={selectPrev ?? null}
        onSubmit={handleLocalSubmit}
        onClose={() => setOpenAcaoAprev(false)}
        onOpenChangeHistory={(id, tabelaTipo) => onOpenChangeHistory(id, tabelaTipo)}
      />
    </>
  );
});